import { useAtomValue } from "jotai";

import Button from "components/Button";
import Flex from "components/Flex";
import { ErrorIcon } from "components/Icons/Error";
import NumberInput from "components/NumberInput";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { estimateTotalAtom } from "atoms/estimate";
import { useClientTranslation } from "hooks/useClientTranslation";

import { useCounterOfferForm } from "../hooks/useCounterOfferForm";
import { useSubmitOfferResponse } from "../hooks/useSubmitOfferResponse";
import { useStyles } from "./styles";

export const NegotiateOffer = () => {
  const { t } = useClientTranslation();
  const estimateTotal = useAtomValue(estimateTotalAtom);

  const { counterOffer, onType, isValid } = useCounterOfferForm();
  const { negotiateSTPOffer, declineSTPOffer } = useSubmitOfferResponse();

  const currencyUnit = estimateTotal!.replace(/[\d,.]/g, "");

  const isInErrorState = counterOffer !== undefined && !isValid;
  const { classes } = useStyles({ isInErrorState });

  return (
    <PageLayout title={t("proposed_offer.header")} dataTestId="negociateOffer">
      <Flex py={16} px={24} direction="column">
        <Text sizeVariant="md">{t("proposed_offer.instruction")}</Text>

        <Flex
          direction="row"
          justify="space-between"
          mt={16}
          mb={32}
          p={"8px 16px 8px 24px"}
          className={classes.offerContainer}
        >
          <Text sizeVariant="md" className={classes.counterOffer}>
            {t("proposed_offer.current_offer")}
          </Text>
          <Text sizeVariant="md">{estimateTotal}</Text>
        </Flex>

        <NumberInput
          name="counterOffer"
          placeholder="0"
          onChange={onType}
          size="xl"
          rightSection={<Text sizeVariant="lg">{currencyUnit}</Text>}
          classNames={{ input: classes.input, rightSection: classes.rightSection }}
          {...(counterOffer === undefined ? {} : { value: counterOffer })}
        />

        <Flex direction="row" mt={16} mb={32} className={classes.errorWrapper}>
          <ErrorIcon height="13" width="13" className={classes.errorIcon} />
          <Text sizeVariant="base" className={classes.errorText}>
            {t("proposed_offer.error.body")}
          </Text>
        </Flex>
        <>
          <Button typeVariant="secondary" mb={16} onClick={declineSTPOffer}>
            {t("global.decline")}
          </Button>
          <Button onClick={() => !!counterOffer && negotiateSTPOffer(counterOffer)} disabled={!isValid}>
            {t("global.submit")}
          </Button>
        </>
      </Flex>
    </PageLayout>
  );
};
